module.exports = __webpack_public_path__ + "static/media/map-outline.6dd09760.svg";